module.exports = __webpack_public_path__ + "icons/original/large/large-e5.b1fdec84ea77accaea3f9a52908d69f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-e5.png
// module id = hli+
// module chunks = app